<script lang="ts">
    import type {AvailableSize} from './types';
    import KpLoadingImg from './KpLoadingImg.svelte';

    export let size: AvailableSize = 'md';
</script>

<span class="kp-loading-wrapper">
    <span class:loading-wrapper={$$slots.default}>
        <KpLoadingImg {size}/>
    </span>

    <slot/>
</span>

<style lang="less">
    .loading-wrapper {
        margin-right: 3px;
    }
</style>